(exports.formatDate = (value) => {
  //
  let date = new Date(parseInt(value) * 1000);
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  return m + "月" + d + "日 ";
}),
  (exports.formatTime = (value) => {
    //10位时间戳转换
    let date = new Date(parseInt(value) * 1000);
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let minute = date.getMinutes();
    minute = minute < 10 ? "0" + minute : minute;
    return h + ":" + minute;
  });
